<template>
  <div class="row">
    <router-link
      :to="{
        name: 'edit-project',
        params: { projectId: this.$route.params?.projectId }
      }"
    >
      <span
        class="btn btn-sm btn-primary float-end d-flex"
      >
        Groep aanpassen
        <span class="material-icons-round ms-2">
          edit_note
        </span>
      </span>
    </router-link>
  </div>

  <div class="row">
    <ProjectCard 
      v-for="project in childProjects"
      :key="project.id"
      :title="project.title"
      :sub-title="project.subTitle"
      :project-id="project.id"
      :image="project.visualImage"
    />
  </div>

  <div class="row">
    <ProjectItemCard
      description="Klik op de button om een projectitem toe te voegen"
      featured
      :is-new-item="false"
      :image="require('@/assets/img/events/meeting.webp')"
    />
    
    <ProjectItemCard
      v-for="projectItem in projectItems"
      :key="projectItem.id"
      :project-item-id="projectItem.id"
      :title="projectItem.title"
      :description="projectItem.description"
      :pinned-date="projectItem.pinnedDate"
      :create-date="projectItem.createDate"
      :image="projectItem.visualImage"
    />
  </div>
</template>

<script>
import { get } from '@/api/providers/projects';
import { getAll } from '@/api/providers/projectItems';
import ProjectCard from '@/components/Projects/Card.vue';
import ProjectItemCard from '@/components/ProjectOverview/Card.vue';

export default {
  name: 'ProjectOverview',

  components: {
    ProjectCard,
    ProjectItemCard,
  },

  data: () => ({
    childProjects: [],
    projectItems: [],
  }),

  watch: {
    '$route.params.projectId'(current, old) {
      if (current == null) return;
      
      if (current != old) {
        this.loadChildProjects();
        this.loadProjectItems();
      }
    }
  },

  created() {
    this.loadChildProjects();
    this.loadProjectItems();
  },

  methods: {
    loadChildProjects() {
      get(this.$route.params.projectId)
        .then((project) => {
          this.childProjects = project.children ?? [];
          console.log(this.childProjects);
        })
    },
    loadProjectItems() {
      getAll(this.$route.params.projectId)
        .then((items) => { 
          this.projectItems = items
        })
        .catch((error) => error.default());
    },
  },
};
</script>